import { BarChart, BarChartProps } from 'Components/BaseCharts/BarChart';
import { CSSColors } from 'Components/Colors';

export interface ControlBarData {
    unrated: number;
    fail: number;
    weak: number;
    moderate: number;
    strong: number;
    robust: number;
}

interface ControlBarGraphProps {
    controlBarData: ControlBarData;
    yAxisLabel: string;
    onItemClick: (item: string) => void;
}

export const ControlBarGraph = (props: ControlBarGraphProps) => {
    const barAndLineChart: BarChartProps = {
        onChartClick: props.onItemClick,
        bars: {
            name: 'Effectiveness',
            color: CSSColors.LIGHT_BLUE,
            data: [
                { value: props.controlBarData.robust, itemStyle: { color: CSSColors.DARK_GREEN } },
                { value: props.controlBarData.strong, itemStyle: { color: CSSColors.LIGHT_GREEN } },
                { value: props.controlBarData.moderate, itemStyle: { color: CSSColors.YELLOW } },
                { value: props.controlBarData.weak, itemStyle: { color: CSSColors.ORANGE } },
                { value: props.controlBarData.fail, itemStyle: { color: CSSColors.RED } },
                { value: props.controlBarData.unrated, itemStyle: { color: CSSColors.DARK_GRAY } },
            ],
        },
        xAxisLabels: ['Robust', 'Strong', 'Moderate', 'Weak', 'Fail', 'Unrated'],
        yAxisInfo: [
            {
                minInterval: 1,
                name: props.yAxisLabel,
                position: 'left',
            },
        ],
    };

    return <BarChart {...barAndLineChart} />;
};
